export class HelperService {
    public static generateURL (module: string, action: string) {
        return HelperService.generateRoute(module + '_' + action);
    }

    public static generateRoute (route: string) {
        return process.env.REACT_APP_API_URL_NAME_PREFIX + route;
    }

    public static generateFoUrl(route: string): string
    {
        return process.env.REACT_APP_FO_HOST + route + '?fromBo=1';
    }
}